import { z } from "zod"

export const sendMyQuoteSchema = z.object({
  email_sent_to: z.string().email(),
  tcAccepted: z.literal(true, { errorMap: () => ({ message: "" }) }),
})

export type SendMyQuoteSchema = z.infer<typeof sendMyQuoteSchema>
